import {axiosInstance as mantis} from "./mantis";

export const authenticateUser = (username, password) => {
    const data = {username, password};
    return mantis.post("/auth", data);
};

export const logoutUser = () => {
    const data = {};
    return mantis.post("/auth/logout", data);
};

export const refreshAuthenticationToken = () => {
    return mantis.get("/auth/refresh");
};

export const authenticateWithToken = token => {
    const data = {token};
    return mantis.post("/auth", data);
};

export const resetPassword = (password, token) => {
    const data = {password, token};
    return mantis.put("/auth/password", data);
};
